/**
 * This screen is used to show no access page when Role based access is checked
 * for individual user.
 */
import { Button, Container, Typography, Box } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation, Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";

function NoAccess() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { t } = useTranslation();

  async function handleTryAgain() {
    await queryClient.invalidateQueries(["user-details"]);
    navigate("/");
  }

  return (
    <Container maxWidth="xl" sx={{ paddingY: 2 }}>
      <Box
        minHeight="70vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <Typography variant="h6" textAlign="center">
          <Trans
            i18nKey="noAccess.noAccessMessage"
            components={{ br: <br /> }}
          />
        </Typography>
        <Button variant="contained" size="large" onClick={handleTryAgain}>
          {t("noAccess.tryAgain")}
        </Button>
      </Box>
    </Container>
  );
}

export default NoAccess;
